import React from "react";
import { Copy, Power, PowerOff } from "lucide-react";
import { toast } from "sonner";

export function DokuConfigBanner({ cfg }) {
  if (!cfg) return null;
  const prod = cfg.env === "production";
  const copy = () => navigator.clipboard?.writeText(cfg.notification_url || "").then(() => toast.success("Notification URL disalin"), () => toast.error("Gagal menyalin"));
  return (
    <div className="mt-6 aivora-card flex flex-col gap-3 p-4 sm:flex-row sm:items-center" data-testid="doku-config">
      <div className="flex items-center gap-3">
        <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl ${cfg.enabled ? "bg-emerald-50 text-emerald-600" : "bg-slate-100 text-slate-500"}`}>{cfg.enabled ? <Power size={18} /> : <PowerOff size={18} />}</span>
        <div>
          <p className="flex flex-wrap items-center gap-2 text-sm font-bold text-slate-900">
            DOKU Checkout
            <span className={`rounded-full px-2 py-0.5 text-[10px] font-black tracking-wider ${prod ? "bg-emerald-600 text-white" : "bg-amber-100 text-amber-800"}`} data-testid="doku-env">{(cfg.env || "sandbox").toUpperCase()}</span>
            <span className={`rounded-full px-2 py-0.5 text-[10px] font-bold ${cfg.enabled ? "bg-emerald-50 text-emerald-700" : "bg-rose-50 text-rose-700"}`} data-testid="doku-enabled">{cfg.enabled ? "Aktif" : "Nonaktif · mode simulasi"}</span>
          </p>
          <p className="text-[11px] text-slate-500">{cfg.api_base || "—"}{cfg.client_id_hint ? ` · Client ID ${cfg.client_id_hint}` : ""}</p>
        </div>
      </div>
      <label className="min-w-0 flex-1 sm:ml-auto sm:max-w-xl">
        <span className="text-[10px] font-semibold uppercase tracking-wider text-slate-500">Notification URL (salin ke DOKU Back Office › Notification)</span>
        <div className="mt-1 flex items-center gap-1">
          <input readOnly value={cfg.notification_url || ""} className="input-ui font-mono text-xs" data-testid="doku-notification-url" />
          <button onClick={copy} className="btn-soft shrink-0 rounded-xl px-3 py-2.5" aria-label="Salin" data-testid="doku-copy-url"><Copy size={14} /></button>
        </div>
      </label>
    </div>
  );
}
